<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd form-detail-preview">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">提醒日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sr_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <span class="weui-form-preview__value">{{item.sr_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">送货提醒单号</label>
            <span class="weui-form-preview__value">{{item.sr_source_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO号</label>
            <span class="weui-form-preview__value">{{item.sr_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">销售单号</label>
            <span class="weui-form-preview__value">{{item.sr_maincode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">明细序号</label>
            <span class="weui-form-preview__value">{{item.sr_detaildetno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{item.sr_prcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{item.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求数量</label>
            <span class="weui-form-preview__value">{{item.sr_qty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">需求日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{item.sr_demand_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{item.sr_remark}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">买家状态</label>
            <span class="weui-form-preview__value">{{item.isEnd ? "已关闭" : "正常送货提醒"}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var item = this.$route.params.item
    return {
      item,
    }
  }
}
</script>